import { render, staticRenderFns } from "./stage-intro.vue?vue&type=template&id=31cddefb&"
import script from "./stage-intro.vue?vue&type=script&lang=js&"
export * from "./stage-intro.vue?vue&type=script&lang=js&"
import style0 from "./stage-intro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports